const name = 'GlideIn';
const properties = {
    hideOnStart: true,
    mobile: true,
    viewportThreshold: 0.15,
    groups: ['entrance', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        angle: {
            type: 'number',
            min: 0,
            max: 360,
            default: 0,
        },
        distance: {
            type: 'number',
            min: 0,
            default: 0,
        },
    },
};
function animate(kit, elements, duration, delay, { angle = properties.schema.angle.default, distance = properties.schema.distance.default, ...params } = {}) {
    const angleInRad = (angle * Math.PI) / 180;
    const transformX = Math.sin(angleInRad) * distance;
    const transformY = Math.cos(angleInRad) * distance * -1;
    const fadeDuration = 0;
    const sequence = kit.sequence(params);
    sequence.add([
        kit.animate('BaseFade', elements, fadeDuration, 0, {
            from: { opacity: 0 },
            to: { opacity: 1 },
            ease: 'Sine.easeIn',
        }),
        kit.animate('BasePosition', elements, duration, delay, {
            from: { x: transformX, y: transformY },
            ease: 'Cubic.easeOut',
        }),
    ], 0);
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=glideIn.js.map